module.exports = "/assets/without-account-active.png?WbMsfl8";